export default __webpack_public_path__ + "static/media/normal.9a786cac.jpg";